import React from 'react';
import { Link } from 'react-router-dom';
 

const AboutSection = () => {
  return (
    <section className="about-container-version bg-dark-main text-white py-5">
      <div className="container position-relative section-grid-wrapper">
        
        {/* Architectural Grid Overlay - Now safely contained inside the wrapper bounds */}
        <div className="contained-grid-lines position-absolute w-100 h-100 top-0 start-0 pointer-events-none">
          <div className="grid-line horizontal-row-split"></div>
          <div className="grid-line left-vertical-split"></div>
          <div className="grid-line right-vertical-split"></div>

          {/* Matrix Point Anchors */}
          <span className="matrix-anchor anchor-tl"></span>
          <span className="matrix-anchor anchor-tm"></span>
          <span className="matrix-anchor anchor-tr"></span>
          <span className="matrix-anchor anchor-ml"></span>
          <span className="matrix-anchor anchor-mm"></span>
          <span className="matrix-anchor anchor-mr"></span>
          <span className="matrix-anchor anchor-bl"></span>
          <span className="matrix-anchor anchor-bm"></span>
          <span className="matrix-anchor anchor-br"></span>
        </div>

        {/* TOP COMPONENT SEGMENT */}
        <div className="grid-layout-top">
          {/* Section Indicator Label */}
          <div className="label-block py-4 py-lg-5">
            <h6 className="uppercase-tag tracking-widest text-muted-gray m-0">
              About<br />  Affsoft IT Solutions Pvt. Ltd.
            </h6>
          </div>
          
          {/* Main Hero Header Statement */}
          <div className="hero-statement-block py-4 py-lg-5 ps-4 ps-lg-5">
            <h2 className="display-4 main-headline-text m-0 fw-normal">
              We help <br />
              to <span className="serif-italic-accent text-lowercase"> Empowering Businesses Through Digital Innovation </span>  
            </h2>
          </div>
        </div>

        {/* BOTTOM COMPONENT SEGMENT */}
        <div className="grid-layout-bottom">
          {/* Metric Dashboard Unit */}
          <div className="metrics-showcase-block py-5 pe-lg-4 d-flex flex-column flex-md-row align-items-md-center gap-4 gap-md-5">
            <div className="counter-box position-relative d-inline-block flex-shrink-0">
              <h1 className="display-1 bold-metric-number m-0 fw-bold">9+</h1>
              <div className="tilted-orange-badge text-nowrap py-1 px-3 bg-orange text-white fw-bold rounded shadow-sm">
                Years of Experience
              </div>
            </div>
            
            <div className="narrative-textbox mt-2 mt-md-0">
              <p className="body-narrative text-muted-gray fs-6 lh-base m-0">
                 Affsoft IT Solutions Pvt. Ltd. is a trusted global technology company delivering innovative IT consulting, software development, cloud solutions, and digital transformation services. We help startups, small and medium-sized businesses, and enterprises accelerate growth through modern technology, automation, and scalable digital solutions.
              </p>

              <p className="body-narrative text-muted-gray fs-6 lh-base m-0">
                 Our mission is to simplify complex business challenges with intelligent technology. From custom software development to enterprise cloud solutions, our experienced professionals deliver secure, high-performance, and future-ready applications that drive measurable business results.
              </p>
            </div>
          </div>

          {/* Direct Interactive Link Circle Box */}
          <div className="action-cta-block py-5 d-flex align-items-center justify-content-center position-relative" style={{ zIndex: 10 }}>
  <Link to="/contact-us"   className="action-circle-link border rounded-circle d-flex flex-column align-items-center justify-content-center text-decoration-none transition-all">
              <span className="arrow-indicator fs-4 mb-1">↗</span>
              <span className="btn-label text-white fw-bold small text-uppercase tracking-wider">CONTACT US</span>
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

export default  AboutSection;